/** Trial end date formatted for display (e.g. "February 2, 2026"). */
export function getTrialEndDateFormatted(trialDays: number): string {
  const d = new Date();
  d.setDate(d.getDate() + trialDays);
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

/** Replaces {{trialEndDate}} in trial detail with formatted date. */
export function formatTrialDetail(template: string, trialDays: number): string {
  const date = getTrialEndDateFormatted(trialDays);
  return template.replace('{{trialEndDate}}', date);
}
